export function toTitleCase(str: string): string {
  return str.replace(/([a-z])([A-Z])/g, "$1 $2").toUpperCase();
}

export function formatPhoneNumber(num: string): string {
  return num
    .replace(/\D/g, "")
    .replace(/^(\d{3})(\d{3})(\d{0,4})$/, "$1 $2 $3")
    .trim();
}

export function normalizePhone(code: string, phone: string) {
  const codeWithoutPlus = code.replace("+", "");
  const cleanPhone = phone.replace(/\D/g, "");
  return `${codeWithoutPlus}${cleanPhone}`;
}

export function getInitials(fullName?: string): string {
  if (!fullName) return "A";
  const parts = fullName.trim().split(" ");
  if (parts.length === 1) return parts[0][0].toUpperCase();
  return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
}

export function stripHtmlTags(text: string): string {
  if (!text) return "";
  return text.replace(/<\/?[^>]+(>|$)/g, "");
}

export const toMillis = (value: any): number => {
  if (!value) return 0;
  if (value.toMillis) return value.toMillis();
  if (value.seconds) return value.seconds * 1000;
  return new Date(value).getTime();
};

export const formatCurrency = (value: number) =>
  value
    ? new Intl.NumberFormat("es-CO", {
        style: "currency",
        currency: "COP",
        maximumFractionDigits: 0,
      }).format(value)
    : "";

export const currencyTransform = (v: string) => {
  const raw = v.replace(/\D/g, "");
  return Number(raw || "0");
};

export function maskId(
  value: string,
  visibleLast: number = 6,
  maskChar: string = "*"
): string {
  if (!value || value.length <= visibleLast) {
    return value;
  }
  const visiblePart = value.slice(-visibleLast);
  const maskedPart = maskChar.repeat(8);
  return `${maskedPart}${visiblePart}`;
}
